var React = require('react');

function LongArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M196 160.11V456a24 24 0 0 1-24 24h-24a24 24 0 0 1-24-24V160.11l36-35.66z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M7 174.58L142.52 39l.06-.06a25.23 25.23 0 0 1 34.84 0l.06.06L313 174.58a24 24 0 0 1 0 33.94l-17 17a24 24 0 0 1-33.94 0L160 124.45 58 225.52a24 24 0 0 1-33.94 0l-17-17A24 24 0 0 1 7 174.58z","className":"fa-primary","key":2})]);
}

LongArrowUp.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = LongArrowUp;

LongArrowUp.default = LongArrowUp;
